// extracted by mini-css-extract-plugin
export default {"slick-slider-item":"items-slider_slick-slider-item__zOdFv","slick-slider-item-content":"items-slider_slick-slider-item-content__ybdCK"};